import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n/client-i18n';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { ServicesProvider } from '@wix/experts-common';
import createStore from './store';
import App from './components/App/App';
import { initialI18n, locale, isInternal, userAgent } from './fromWindow';
import { initMoment } from './utils/moment';
import isMobile from './utils/isMobile';
import { BASE_URL_MARKETPLACE } from './utils/constants';
import { HelmetProvider } from 'react-helmet-async';

initMoment(locale);

const url = `${window.location.pathname.replace(BASE_URL_MARKETPLACE, '')}${
  window.location.search
}`;
const { store, history, services } = createStore({
  url,
  isInternal,
  isMobile: isMobile(userAgent),
});

ReactDOM.hydrate(
  <HelmetProvider>
    <Provider store={store}>
      <I18nextProvider i18n={i18n(initialI18n)}>
        <ServicesProvider services={services}>
          <ConnectedRouter history={history}>
            <App />
          </ConnectedRouter>
        </ServicesProvider>
      </I18nextProvider>
    </Provider>
  </HelmetProvider>,
  document.getElementById('root'),
);
